import { Dialog } from '@angular/cdk/dialog';
import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { AlertService } from '@app/core';
import { Attachment } from '@app/core/models';
import { AttachmentService } from '@app/core/services/attachment.service';
import { ModalFileViewerComponent } from '@app/modules/eclass/components/modal-file-viewer/modal-file-viewer.component';
import { SHARED_MODULES } from '@app/shared';
import { notNull, safeEmpty } from '@app/shared/utils';
import { ModalTrailStudentComponent } from '../modal-trail-student/modal-trail-student.component';

@Component({
  selector: 'app-resource-component',
  imports: [SHARED_MODULES],
  templateUrl: './resource-component.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResourceComponentComponent {
  public readonly dialog = inject(Dialog);
  public readonly _alertService = inject(AlertService);
  public readonly _attachmentService = inject(AttachmentService);
  @Input({ required: true }) public title: string;
  @Input({ required: true }) public attachments;
  @Input() public bgColor: string;

  public onIconFile(extension: string): string {
    switch (extension) {
      case 'xls':
        return 'assets/images/files/xls.svg';
      case 'pdf':
        return 'assets/images/files/pdf.svg';
      case 'mp3':
        return 'assets/images/files/mp3.svg';
      case 'mp4':
        return 'assets/images/files/mp4.svg';
      case 'doc':
        return 'assets/images/files/doc.svg';
      case 'pptx':
        return 'assets/images/files/ppt.svg';
      case 'jpg':
        return 'assets/images/files/jpg.svg';
      case 'png':
        return 'assets/images/files/png.svg';
      case 'txt':
        return 'assets/images/files/txt.svg';
      default:
        return 'assets/images/files/doc.svg';
    }
  }

  public onOpenFile(attachment: Attachment): void {
    this.dialog.open(ModalFileViewerComponent, {
      data: {
        title: attachment?.title,
        url: attachment?.url || attachment?.file,
        type: attachment?.type ?? null,
        file: attachment?.file,
      },
    });
  }

  public onDownload(attachmentId: number): void {
    this._attachmentService
      .getPresignedDownloadUrl(attachmentId)
      .pipe(safeEmpty())
      .subscribe({
        next: ({ download_url, title }) => {
          const a = document.createElement('a');
          a.href = download_url;
          a.download = title;
          a.click();
        },
        error: () => this._alertService.alert({ message: 'geral.erro-download' }),
      });
  }

  public onOpenModal() {
    this.dialog.open<boolean>(ModalTrailStudentComponent, {}).closed.pipe(notNull());
  }

  public canDownload(extension: string) {
    const ext = ['pdf', 'jpg', 'jpeg', 'xls', 'xlsx', 'ppt', 'pptx', 'doc', 'docx', 'png'];

    return ext.includes(extension);
  }
}
